import { render, staticRenderFns } from "./app-whoami.vue?vue&type=template&id=5b9516fd&"
import script from "./app-whoami.vue?vue&type=script&lang=js&"
export * from "./app-whoami.vue?vue&type=script&lang=js&"
import style0 from "./app-whoami.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports